import React, { forwardRef } from "react";
import { Button, Tooltip } from "@chakra-ui/react";
import { colours } from "@/utils/themeUtils";
import { ChakraFAIcon } from "@/components/ui/Icon";
import { qoriaColours } from "@/theme/colours";

interface Props {
	icon: string;
	label: string;
	disabled?: boolean;
	/** Tooltip shown when the button is disabled (e.g. seat plan edit/selection mode) */
	disabledTooltip?: string;
	handleClick?: () => void;
	altText?: string;
	iconOnRightSide?: boolean;
	iconColor?: string;
	danger?: boolean;
	testId?: string;
	borderColour?: string;
}

export const ActionButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const { icon, label, disabled, altText, iconOnRightSide, danger, testId } = props;

	const iconColor = props.iconColor || (danger ? " #B11325" : "#6B778C");
	const textColor = danger ? "#B11325" : colours.navy[800];
	const backgroundColor = danger ? "#FFDBDF" : qoriaColours.brand.neutral[10];
	const hoverBackgroundColor = danger ? "#fabec5" : "#F3F5F9";
	const borderColor = danger ? "#B1132522" : props.borderColour ? props.borderColour : qoriaColours.brand.neutral[10];

	const button = (
		<Button
			ref={ref}
			columnGap={3}
			title={disabled ? undefined : altText}
			onClick={props.handleClick}
			py={0}
			border={`1px solid ${borderColor}`}
			rounded={"6px"} // Hack to prevent FZLC Chakra theme in Courses microfrontend from overriding the border radius
			background={backgroundColor}
			color={textColor}
			_hover={{
				background: hoverBackgroundColor,
			}}
			_disabled={{
				bg: colours.neutrals[100],
				color: colours.neutrals[300],
				cursor: "not-allowed",
			}}
			isDisabled={disabled}
			data-testid={testId}
		>
			{!iconOnRightSide && <ChakraFAIcon icon={icon} variant="solid" color={iconColor} boxSize={4} />}
			{label}
			{iconOnRightSide && <ChakraFAIcon icon={icon} variant="solid" color={iconColor} boxSize={4} />}
		</Button>
	);

	if (disabled && props.disabledTooltip) {
		return (
			<Tooltip label={props.disabledTooltip} placement="top" hasArrow shouldWrapChildren>
				<span style={{ display: "inline-block" }}>{button}</span>
			</Tooltip>
		);
	}

	return button;
});
